import React from "react";

const WhyChooseSection = () => {
  return (
    <section className="section why-choose">
      <div className="choose-left">
        <img
          src="/img/bg/choose-left.png"
          className="img-fluid"
          alt="Why Choose Omshree Cabs"
        />
      </div>

      <div className="container">
        {/* Heading */}
        <div className="section-heading" data-aos="fade-down">
          <h2>Why Choose Omshree Cabs</h2>
          <p>
            Safe, reliable, and comfortable rides for every journey, anytime, anywhere.
          </p>
        </div>

        {/* Cards */}
        <div className="why-choose-group">
          <div className="row">
            {/* Card 1 */}
            <div className="col-lg-4 col-md-6 col-12 d-flex" data-aos="fade-down">
              <div className="card flex-fill">
                <div className="card-body">
                  <div className="choose-img choose-black">
                    <img src="/img/icons/bx-selection.svg" alt="Easy & Fast Booking" />
                  </div>
                  <div className="choose-content">
                    <h4>Easy & Fast Booking</h4>
                    <p>
                      Book your ride in just a few clicks. Our streamlined process ensures you get a cab quickly and hassle-free.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Card 2 */}
            <div className="col-lg-4 col-md-6 col-12 d-flex" data-aos="fade-down">
              <div className="card flex-fill">
                <div className="card-body">
                  <div className="choose-img choose-secondary">
                    <img src="/img/icons/bx-crown.svg" alt="Multiple Pickup Locations" />
                  </div>
                  <div className="choose-content">
                    <h4>Multiple Pickup Locations</h4>
                    <p>
                      Choose from numerous pickup points including airports, railway stations, hotels, or city destinations. Omshree Cabs is always nearby.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Card 3 */}
            <div className="col-lg-4 col-md-6 col-12 d-flex" data-aos="fade-down">
              <div className="card flex-fill">
                <div className="card-body">
                  <div className="choose-img choose-primary">
                    <img src="/img/icons/bx-user-check.svg" alt="Customer Satisfaction" />
                  </div>
                  <div className="choose-content">
                    <h4>Customer Satisfaction</h4>
                    <p>
                      Our top priority is your comfort and safety. Enjoy professional drivers, clean vehicles, and a smooth ride every time.
                    </p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;